import Vue from 'vue'
import * as httpConst from '../../../../constants/httpConst'
import * as types from '../../../mutation-types/driver-types'

const API_PATH = `${httpConst.DRIVER_ENDPOINT}/masters/handle_items`

const getDefaultState = () => {
  return {
    pagination: {
      current_page: 1,
      total_count: 0
    },
    condition: {
      type: 'industrial',
      limit: 50,
    },
  }
}

const handle_item = {
  namespaced: true,
  state: getDefaultState(),
  getters: {},
  actions: {
    /**
     * 使用品目取得
     * @param dispatch
     * @param commit
     * @param condition
     * @param page
     * @return {Promise<unknown>}
     */
    index ({ dispatch, commit }, { condition, page }) {
      dispatch('saveCondition', { condition: condition })
      const params = {
        ...condition,
        page: page
      }
      return new Promise((resolve) => {
        Vue.$http.get(API_PATH, { params: params }).then(data => {
          let content = data.content
          // commit(types.DRIVER_ITEM_PAGINATION, { content })
          resolve(content)
        })
      })
    },
    show ({ commit }, { id }) {
      const api_path = `${API_PATH}/${id}`
      return new Promise((resolve) => {
        Vue.$http.get(api_path).then(data => {
          commit
          resolve(data.content)
        })
      })
    },
    edit ({ commit }, { type }) {
      const api_path = `${API_PATH}/edit`
      const params = { type: type }
      return new Promise((resolve) => {
        Vue.$http.get(api_path, { params: params }).then(data => {
          resolve(data.content)
        })
      })
    },
    create ({ commit },{ params }) {
      return new Promise( ( resolve ) => {
        Vue.$http.post(API_PATH, params).then( data => {
          let content = data.content
          commit('snackbar/showInfo', { message: '更新しました' }, { root: true })
          resolve(content)
        } )
      })
    },
    update ({ commit },{ id, params }) {
      const api_path = `${API_PATH}/${id}`
      return new Promise( ( resolve ) => {
        Vue.$http.put(api_path, params ).then( data => {
          let content = data.content
          commit('snackbar/showInfo', { message: '更新しました' }, { root: true })
          resolve(content)
        } )
      })
    },
    destroy ({ commit }, { id }) {
      const api_path = `${API_PATH}/${id}`
      return new Promise( ( resolve ) => {
        Vue.$http.delete(api_path).then(data => {
          commit('snackbar/showInfo', { message: '削除しました' }, { root: true })
          resolve(data.content)
        })
      })
    },
    saveCondition ({ commit, state }, { condition } = {}) {
      const _type = (condition.type !== undefined) ? condition.type : state.condition.type;
      const _limit = (condition.limit !== undefined) ? condition.limit : state.condition.limit;
      const params = {
        type: _type,
        limit: _limit,
      }
      commit(types.DRIVER_ITEM_CONDITION, { params })
    },
    resetState ({ commit }) {
      commit(types.DRIVER_ITEM_RESET_CONDITION)
    },
  },
  mutations: {
    [types.DRIVER_ITEM_CONDITION] (state, { params }) {
      Object.assign(state.condition, params);
    },
    [types.DRIVER_ITEM_RESET_CONDITION] (state) {
      Object.assign(state, getDefaultState())
    },
  },
}

export default handle_item

